module.exports = __webpack_public_path__ + "static/02-e2ae4faa377feb836b83b23150aec516.jpg";